/**
 * データ整合（/reconcile）— 2026-07-28 タブ化
 *
 *   タブ1「Notionデータ整合」 … sys と Notion 車両マスタの存在差分 / 修理未完了（2026-07-12 版のまま）
 *   タブ2「システムデータ整合」 … 予約データの抽出・一括編集・バックアップ・復元
 *
 * タブは内部 state（?tab=system で直リンク可）。App.tsx のルート定義は変更していない
 * （/reconcile は 2 箇所に登録されている: App.tsx:249 と App.tsx:410）。
 *
 * 仕様: md/master_md/page-reconcile.md
 */
import React from 'react';
import { Box, Typography, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DashboardSidebar from '../components/DashboardSidebar';
import NotionTab from './reconcile/NotionTab';
import SystemTab from './reconcile/SystemTab';

const TAB_KEYS = ['notion', 'system'] as const;

const Reconcile: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabKey = searchParams.get('tab') === 'system' ? 'system' : 'notion';
    const tabIndex = TAB_KEYS.indexOf(tabKey);

    const handleChange = (_: React.SyntheticEvent, next: number) => {
        const key = TAB_KEYS[next] || 'notion';
        // 既定タブ（notion）のときはクエリを付けない
        if (key === 'notion') setSearchParams({}, { replace: true });
        else setSearchParams({ tab: key }, { replace: true });
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
            <DashboardSidebar />

            <Box
                component="main"
                sx={{
                    flexGrow: 1, minWidth: 0, p: { xs: 2, md: 4 }, pt: { xs: 7, md: 4 },
                    display: 'flex', flexDirection: 'column', height: '100vh', boxSizing: 'border-box',
                }}
            >
                <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CompareArrowsIcon /> データ整合
                </Typography>

                <Tabs
                    value={tabIndex}
                    onChange={handleChange}
                    sx={{ mb: 2, borderBottom: 1, borderColor: 'divider', minHeight: 40 }}
                >
                    <Tab label="Notionデータ整合" sx={{ fontWeight: 700, minHeight: 40 }} />
                    <Tab label="システムデータ整合" sx={{ fontWeight: 700, minHeight: 40 }} />
                </Tabs>

                <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0 }}>
                    {tabKey === 'notion' ? <NotionTab /> : <SystemTab />}
                </Box>
            </Box>
        </Box>
    );
};

export default Reconcile;
